import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.8644 16.955L13.8531 13.9437M16.004 8.78136C16.004 12.8204 12.7297 16.0946 8.69071 16.0946C4.6517 16.0946 1.37744 12.8204 1.37744 8.78136C1.37744 4.74236 4.6517 1.46809 8.69071 1.46809C12.7297 1.46809 16.004 4.74236 16.004 8.78136Z",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		stroke: "currentColor"
	})
});
export default SvgSearchIcon;
